import React from 'react';
import { Stack, SxProps, Typography } from 'components/base';
import { error, grey, text } from 'assets/colors';

const boxStyle: SxProps = {
  backgroundColor: grey.custom1,
  borderRadius: 1,
  padding: 2,
  height: '220px',
  opacity: 0.8,
};

export const CannotBePrefilledElement: React.FC<{
  element: {
    label: string;
    name: string;
    isRequired: boolean;
  };
  isTableField?: boolean;
}> = ({ element, isTableField = false }) => {
  return (
    <Stack m={1} sx={boxStyle}>
      {!isTableField && (
        <Typography variant="subtitle2" color={text.disabled}>
          {element?.label}{' '}
          {element?.isRequired && <span style={{ color: error.main }}>*</span>}
        </Typography>
      )}
      <Typography variant="subtitle1" color="text.primary" alignSelf="center">
        This question cannot be prefilled.
      </Typography>
    </Stack>
  );
};
